import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "checkbox", "drawer"]
  
  localStorageKey = "networkTestModalDismissed"

  connect() {
    if(this.hasFormTarget && this.modalDismissed()){
      const form = $(this.formTarget).parents("form")
      const confirmed = $("<input value=\"true\" type=\"hidden\" name=\"confirmed\" id=\"confirmed\">")
      form.append(confirmed)
      form.attr("data-turbo", "false")
    }

    if(this.hasCheckboxTarget){
      $(this.checkboxTarget).on("change", (e) => {
        const checked = $(e.target).prop("checked")
        if(checked){
          localStorage.setItem(this.localStorageKey, "true")
        }
        else{
          localStorage.removeItem(this.localStorageKey)
        }
      })
    }
  }

  modalDismissed() {
    const dismissed = localStorage.getItem(this.localStorageKey)

    return dismissed === "true"
  }

  showDrawer(_) {
    $(this.drawerTarget).modal("show")
  }
}
